import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const style = {
  grid: {
    marginTop: "0px",
    marginBottom: "0px",
  },
};

function GridContainer({ ...props }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { classes, children, className, ...rest } = props;

  return (
    <Grid
      container
      {...rest}
      className={classes.grid + " " + className}
      spacing={isMobile ? 4 : 10}
    >
      {children}
    </Grid>
  );
}

export default withStyles(style)(GridContainer);
